<app-load-general [load]="isLoading()"></app-load-general>

<div class="flex min-h-screen">
  <div class="hidden lg:flex lg:w-1/2 relative overflow-hidden" style="background-image: url('assets/img/fondo.png'); background-size: cover; background-position: center;">
    <div class="absolute inset-0 bg-black/50"></div>

    <div class="relative z-10 flex flex-col justify-between p-12 lg:p-16 w-full">
      <div class="flex items-center gap-4"></div>

      <div class="space-y-12 max-w-lg mx-auto text-left">
        <div class="flex justify-start">
          <img src="assets/img/logoblanco.webp" alt="Smart Visits"  />
        </div>

      </div>

      <div class="flex items-center gap-3" style="color: var(--color-login-text-secondary);">
        <mat-icon class="text-xl">lock</mat-icon>
        <div class="text-sm">
          <p class="font-medium" style="color: var(--color-login-text-primary);">{{ 'login.secureAccess' | translate }}</p>
          <p style="color: var(--color-login-text-muted);">{{ 'login.protectedData' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 login-right-panel">
    <div class="w-full max-w-xl">
      <div class="lg:hidden flex justify-center mb-6">
        <img src="assets/img/logoblanco.webp" alt="Smart Visits" class="h-25" />
      </div>

      <div class="rounded-2xl p-8 sm:p-10 login-form-card"
        style="background-color: var(--color-bg-primary); box-shadow: 0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05);">
        <div class="flex items-center gap-4 text-left mb-8">
          <div class="shrink-0 w-14 h-14 rounded-full flex items-center justify-center login-icon-bg lg:flex">
            <mat-icon class="text-3xl" style="color: var(--color-primary);">lock</mat-icon>
          </div>
          <div>
            <h2 class="text-2xl sm:text-3xl font-bold mb-1 login-title">{{ 'login.title' | translate }}</h2>
            <p class="login-subtitle">{{ 'login.subtitle' | translate }}</p>
          </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="login()" class="space-y-4">
          <div class="mt-4">
            <app-input-general [formControlGeneral]="loginForm.get('username')" [label]="('login.username' | translate)"
              [placeholder]="('login.username' | translate)" type="text">
            </app-input-general>
          </div>

          <div class="mt-4">
            <app-input-general [formControlGeneral]="loginForm.get('password')" [label]="('login.password' | translate)"
              [placeholder]="('login.password' | translate)" [type]="hidePassword() ? 'password' : 'text'">
            </app-input-general>
          </div>

          <button type="submit" [disabled]="isLoading() || loginForm.invalid"
            class="w-full py-3 mt-2 rounded-xl font-semibold text-base flex items-center justify-center gap-3 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
            style="background-color: var(--color-primary); color: var(--color-text-inverse); box-shadow: 0 4px 16px var(--comp-button-shadow);">
            <span>{{ 'common.actions.enter' | translate }}</span>
            <mat-icon class="text-lg">arrow_forward</mat-icon>
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
